var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AutoCompleteComponent } from '@apto/autocomplete';
import { OfferModel, ContactModel } from '@apto/models';
import { ContactsService } from '@apto/services';
import { INTEGER_REGEX, validationMessages } from '@apto/shared';
var EditOfferForm = /** @class */ /*@__PURE__*/ (function () {
    function EditOfferForm(contactsService, formBuilder) {
        this.contactsService = contactsService;
        this.formBuilder = formBuilder;
        this.OfferModel = OfferModel;
        this.isSaving = false;
        this.datepickerOptions = {
            alignSelectorRight: true,
            showSelectorArrow: false
        };
        this.status = Object.values(this.OfferModel.STATUS);
        this.validationMessages = validationMessages;
    }
    EditOfferForm.prototype.ngOnInit = function () {
        if (!this.offer) {
            this.offer = new OfferModel();
        }
        this.setupForm();
    };
    EditOfferForm.prototype.ngOnChanges = function (changes) {
        if (changes.offer &&
            changes.offer.previousValue &&
            changes.offer.previousValue._id !== changes.offer.currentValue._id) {
            this.setupForm();
        }
    };
    EditOfferForm.prototype.saveRelationship = function (autoComplete, attribute, attributeId) {
        if (!autoComplete.getValue()) { // if the text has been deleted, clear the related values
            this.offer[attribute] = this.offer[attributeId] = null;
        }
        else { // otherwise, set values based on the current selection
            var selection = autoComplete.getSelection();
            if (selection) {
                this.offer[attribute] = selection;
                this.offer[attributeId] = selection._id;
            }
        }
    };
    EditOfferForm.prototype.setContact = function (autoComplete, attribute, attributeId) {
        return __awaiter(this, void 0, void 0, function () {
            var contacts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.offer[attribute] && this.offer[attributeId]))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, this.contactsService.in([this.offer[attributeId]])];
                    case 1:
                        contacts = _a.sent();
                        this.offer[attribute] = contacts.length && contacts[0] || null;
                        _a.label = 2;
                    case 2:
                        if (this.offer[attribute]) {
                            autoComplete.setValue(this.offer[attribute].fullName);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EditOfferForm.prototype.save = function () {
        var _this = this;
        if (this.offerForm.valid) {
            Object.assign(this.offer, this.offerForm.value);
            this.saveRelationship(this.purchaserAutoComplete, 'purchaser', 'purchaserId');
            return { offer: this.offer };
        }
        else {
            Object.keys(this.offerForm.controls).forEach(function (fieldKey) {
                _this.offerForm.controls[fieldKey].markAsDirty();
            });
        }
    };
    EditOfferForm.prototype.setupForm = function () {
        var _this = this;
        this.setContact(this.purchaserAutoComplete, 'purchaser', 'purchaserId');
        var validateWithPattern = function (keyField, reg) {
            return [_this.offer[keyField], Validators.pattern(reg)];
        };
        this.offerForm = this.formBuilder.group({
            additionalDeposit: validateWithPattern('additionalDeposit', INTEGER_REGEX),
            closeDate: this.offer && this.offer.closeDate,
            feasibilityPeriod: this.offer && this.offer.feasibilityPeriod || '',
            financingPeriod: this.offer && this.offer.financingPeriod || '',
            independentConsideration: validateWithPattern('independentConsideration', INTEGER_REGEX),
            initialDeposit: validateWithPattern('initialDeposit', INTEGER_REGEX),
            name: this.offer && this.offer.name || '',
            offerDate: [this.offer && this.offer.offerDate, Validators.required],
            offerPrice: validateWithPattern('offerPrice', INTEGER_REGEX),
            status: this.offer && this.offer.status
        });
    };
    EditOfferForm.prototype.setQuickAddRecord = function (record, autoComplete, attribute, attributeId) {
        if (record) {
            this.offer[attribute] = record;
            this.offer[attributeId] = record._id;
            if (record instanceof ContactModel) {
                autoComplete.setValue(record.fullName);
            }
            else {
                autoComplete.setValue(record.name);
            }
            autoComplete.select(record);
        }
    };
    return EditOfferForm;
}());
export { EditOfferForm };
